export default {
  "territory": {
    "title": "Especificidades do Território",
    "description1": "Na Região Vulcânica a vegetação predominante é formada por florestas tropicais do tipo Mata Atlântica. De solo vulcânico, as altitudes das lavouras variam entre 700 e 1.300 metros, com uma média de 1.075 metros.",
    "description2": "A temperatura anual média está entre 17 e 20°C, e a pluviosidade média é de 1.686 mm na região, proporcionando condições excepcionais para uma cafeicultura de altíssima qualidade.",
    "impact_title": "Impacto da Cafeicultura na Região*",
    "producers": "Produtores",
    "production_area": "Área de Produção",
    "population": "População",
    "direct_jobs": "Empregos Diretos",
    "annual_production": "Produção Anual",
    "annual_production_unit": "(Sacas 60kg/ano)",
    "indirect_jobs": "Empregos Indiretos",
    "unit": "milhão",
    "footnote": "*Soma dos 12 municípios que compõem a área demarcada"
  }
}
